import {eventNameConst, stateConst} from '../conf';
import {computeEdgePoints} from '../core/logic/edge';

/**
 * 拓扑插件-边相关事件
 */


/**
 * 拓扑插件-节点-初始化边相关事件
 * @param that vue实例
 */
export function initEdgeEvent(that) {
  const stage = that.getCanvasStage();

  // 监听鼠标离开节点
  stage.on(eventNameConst.edgeEvent.mouseEnter, evt => {
    const item = evt.item;
    // 设置目标节点的 hover 状态 false
    item.setState(stateConst.active, true);
  });


  // 监听鼠标悬停节点
  stage.on(eventNameConst.edgeEvent.mouseOver, evt => {
    const item = evt.item;
    // const point = stage.getPointByClient(evt.clientX, evt.clientY);
    // const clientPoint = stage.getClientByPoint(evt.canvasX, evt.canvasY);
    // console.log(evt, JSON.stringify(clientPoint), '页面转换坐标', evt);
    // const canvasPoint = stage.getCanvasByPoint(nodeItem.getModel().x, nodeItem.getModel().y);
    // console.log(nodeItem, '悬停', nodeItem.getModel().x, nodeItem.getModel().y, '转换', clientPoint, canvasPoint);

    // 非连线模式
    if (!that.tpOptions.joinLineActive) {
      that.$bus.$emit('custom:edge:info:showDetail', true, item, {x: evt.clientX, y: evt.clientY});
    }
  });


  // 监听鼠标离开节点
  stage.on(eventNameConst.edgeEvent.mouseLeave, evt => {
    const item = evt.item;

    // 设置目标节点的 hover 状态 false
    stage.setItemState(item, stateConst.active, false);

    // 非连线模式
    if (!that.tpOptions.joinLineActive) {
      that.$bus.$emit('custom:edge:info:showDetail', false);
    }
  });


  // 监听鼠标点击节点
  stage.on(eventNameConst.edgeEvent.click, evt => {
    const item = evt.item;
    console.log(item, '边数据', item.getModel());

    // 赋值右侧属性表单
    that.$bus.$emit('custom:shape:attrChange', item);

    // 非连线模式
    if (!that.tpOptions.joinLineActive) {
      // 设置目标节点的 selected 状态
      item.setState(stateConst.selected, true);
    }
  });


  // 监听鼠标点击节点
  stage.on(eventNameConst.edgeEvent.dblClick, evt => {
    // const item = evt.item;

    if (that.tpOptions.joinLineActive) {
      // 赋值右侧属性表单
      that.$bus.$emit('custom:edge:timing:dbClick', evt);
    }
  });


  // 监控边/连线创建后事件，处理节点间多条边重叠问题
  stage.on(eventNameConst.timingEventName.afterCreateEdge, evt => {
    // const edge = evt.edge;

    // 计算边坐标和曲线
    computeEdgePoints(that);

    // 显示连接关系弹窗
    that.$bus.$emit('custom:edge:timing:afterCreateEdge', evt);
  });

}
